export default __webpack_public_path__ + "static/media/deposit-slip.9cfff69d.svg";